import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { AiService } from '../../services/ai.service';

@Directive({
  selector: '[aiEnabled]',
})
export class AiEnabledDirective implements OnInit, OnDestroy {
  private isHidden: boolean = true;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private viewContainerRef: ViewContainerRef,
    private tplRef: TemplateRef<unknown>,
    private aiService: AiService,
  ) {}

  public ngOnInit(): void {
    this.subscriptions.add(
      this.aiService.aiEnabledForTenant$.subscribe({
        next: (isAiEnabledForTenant: boolean) => this.updateView(isAiEnabledForTenant),
      }),
    );
  }

  private updateView(isAiEnabledForTenant: boolean): void {
    if (!isAiEnabledForTenant) {
      this.viewContainerRef.clear();
      this.isHidden = true;
      return;
    }

    if (this.isHidden) {
      this.viewContainerRef.clear();
      this.viewContainerRef.createEmbeddedView(this.tplRef);
      this.isHidden = false;
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
